import follow from './follow.svg';
import next from './next-page.svg';
import prev from './prev-page.svg';
import endPlay from './end-play.svg';
import endPlayWhite from './end-play-white.svg';
import zoomIn from './zoom-in.svg';
import zoomOut from './zoom-out.svg';
import viewSwitch from './view-switch.svg';

export const FOLLOW = follow;
export const NEXT = next;
export const PREV = prev;
export const END_PLAY = endPlay;
export const END_PLAY_WHITE = endPlayWhite;
export const ZOOM_IN = zoomIn;
export const ZOOM_OUT = zoomOut;
export const VIEW_SWITCH = viewSwitch;
